const zhHK = {
  developer: "開發人員",
  account: "Accounts",
};
export default zhHK;
